import services from '../services'

import { validate } from 'vee-validate'

import '../services/rules'

export const validUser = context => {
  if (
    context.getters.user &&
    context.getters.user.name &&
    context.getters.user.email
  ) {
    const fields = [
      { key: 'name', rule: 'required' },
      { key: 'email', rule: 'required|email' }
    ]

    let invalidFields = 0

    fields.forEach(item => {
      validate(context.getters.user[item.key], item.rule)
        .then(result => {
          if (!result.valid) {
            invalidFields++
          }
        })
        .catch(err => {
          console.error(err)
        })
    })

    return invalidFields >= 1 ? false : true
  } else {
    return false
  }
}

export const validField = (context, fieldValue) => {
  const field = context.getters.form.fields.find(
    f => f.fieldId === fieldValue.id
  )

  const rules = services.getFieldRules()[field.type || field.fieldType]

  if (rules) {
    const isVisible = field.isClientVisible ? field.isClientVisible.value : true

    rules['required'] =
      isVisible &&
      ((field.isMandatory && field.isMandatory.value) || field.required)

    return validate(fieldValue.value, rules)
      .then(result => result.valid)
      .catch(err => {
        console.error(err)
      })
  } else {
    return true
  }
}

async function tryValidCustomFileds(context) {
  if (
    context.getters.ready &&
    context.getters.form &&
    context.getters.form.fields &&
    context.getters.form.fields.length
  ) {
    let customFields = []

    for (let index in context.getters.customFields) {
      let customField = context.getters.customFields[index]

      if (customField.id && customField.value) {
        if (await context.dispatch('validField', customField)) {
          const field = context.getters.form.fields.find(
            f => f.fieldId === customField.id
          )

          customFields.push({
            value: customField.value,
            id: field.fieldId,
            domainType: field.domainType,
            title: field.title,
            type: field.type || field.fieldType
          })
        }
      }
    }

    await context.dispatch('setCustomFields', customFields)

    const requiredFields = context.getters.form.fields.filter(
      field =>
        (field.isClientVisible ? field.isClientVisible.value : true) &&
        ((field.isMandatory && field.isMandatory.value) || field.required)
    )

    return requiredFields.every(rf =>
      customFields.some(cf => cf.id === rf.fieldId)
    )
  } else {
    return true
  }
}

export const validCustomFields = async function (context) {
  return new Promise((resolve, reject) => {
    if (context.getters.fetchingForm) {
      const interval = setInterval(() => {
        if (!context.getters.fetchingForm) {
          clearInterval(interval)
          tryValidCustomFileds(context)
            .then(result => resolve(result))
            .catch(error => reject(error))
        }
      }, 50)
    } else {
      tryValidCustomFileds(context)
        .then(result => resolve(result))
        .catch(error => reject(error))
    }
  })
}
